import { useParams } from "react-router";
import { Link } from "@/components/ui/link";
import { useSustainabilityConfig } from "@/lib/hooks/use-portfolio-collections";
import { useT } from "@/lib/i18n/use-t";

import { TableCardSkeleton } from "../skeleton-loaders";
import { T } from "./page.i18n";
import { SustainabilityConfigEditor } from "./sustainability-config-editor";

export default function SustainabilityPage() {
  const { id } = useParams<{ id: string }>();
  const t = useT(T);
  const { config, isLoading } = useSustainabilityConfig(id!);

  if (isLoading) {
    return <TableCardSkeleton columns={3} />;
  }

  if (config == null) {
    return (
      <div className="rounded-lg border p-6 text-sm text-muted-foreground">
        <p>{t.disabled}</p>
        <Link to={`/settings/portfolios/${id}/settings`} className="text-primary underline">
          {t.enableInSettings}
        </Link>
      </div>
    );
  }

  return <SustainabilityConfigEditor portfolioCollectionId={id!} config={config} />;
}
